import { useMemo } from "react";
import { Line } from "react-konva";
import { TrackWithGeometry } from "@opstel/query/models/track";
import { Point } from "@opstel/geo/Point";
import { PointHelper } from "@opstel/geo/helpers/PointHelper";
import { useEPDStyle } from "../contexts/EPDStyle/useEPDStyle";
import { SCALING_VECTOR } from "../core/layoutConstants";

type BufferStopProps = {
  readonly topoPoint: Point;
  readonly associatedTrack: TrackWithGeometry;
  readonly trackLineWidth: number;
};

const BUFFER_STOP_WIDTH = 22;
export function BufferStop({ topoPoint, associatedTrack, trackLineWidth }: BufferStopProps) {
  const { style } = useEPDStyle();

  const rotation = useMemo(() => {
    const trackCoordinates = associatedTrack.coordinates.fromSourceToTarget;
    const [point1, point2] = (
      PointHelper.equals(topoPoint, trackCoordinates[0])
        ? trackCoordinates.slice(0, 2)
        : trackCoordinates.slice(-2)
    ).map((point) => point.scale(SCALING_VECTOR));

    return PointHelper.getRotation(point1, point2);
  }, [topoPoint, associatedTrack]);

  const drawPoint = topoPoint.scale(SCALING_VECTOR);
  const points = [
    drawPoint.x,
    drawPoint.y - (BUFFER_STOP_WIDTH / 2) * trackLineWidth,
    drawPoint.x,
    drawPoint.y + (BUFFER_STOP_WIDTH / 2) * trackLineWidth,
  ];

  return (
    <Line
      x={drawPoint.x}
      y={drawPoint.y}
      points={points}
      offsetX={drawPoint.x}
      offsetY={drawPoint.y}
      rotation={rotation}
      tension={0}
      strokeWidth={trackLineWidth}
      stroke={style.infraItems.BufferStop.lineColor}
      shadowBlur={0}
    />
  );
}
